import { BaseController } from "../../../core/controllers/base.controller";
import { VasAppFacade } from "../../services/vas-app-facade.service";
import { AlertButton, AlertOptions } from "ionic-angular/components/alert/alert-options";
import { isString } from "ionic-angular/util/util";
import { AlertController } from "ionic-angular";

export class LoginController extends BaseController {

    constructor(
        protected appFacade: VasAppFacade,
        protected alertController: AlertController
    ) {
        super();
    }

    showUpdateHostDialog(): void {
        this.appFacade.objects.config.store.getRestHost()
            .take(1)
            .subscribe(host => {
                const alert = this.alertController.create({
                    title: "Update API host",
                    inputs: [
                        {
                            label: "API Host",
                            type: "text",
                            value: host
                        }
                    ],
                    buttons: [
                        {
                            text: "Ok",
                            handler: values => {
                                this.updateApiHost(values[0]);
                            }
                        } as AlertButton,
                        {
                            text: "Default",
                            handler: () => {
                                this.updateApiHost(this.appFacade.config.REST.HOST);
                            }
                        } as AlertButton,
                        {
                            text: "Cancel",
                            role: "cancel"
                        } as AlertButton
                    ]
                } as AlertOptions);

                alert.present();
            });
    }

    protected updateApiHost(value: string): void {

        if (!value || !isString(value)) {
            return;
        }

        this.appFacade.objects.config.store.updateRestHost(value);


    }
}



// WEBPACK FOOTER //
// ./src/vas/pages/login/login.controller.ts